import { render, staticRenderFns } from "./LoadingBlock.vue?vue&type=template&id=79c9aaf3&"
import script from "./LoadingBlock.vue?vue&type=script&lang=js&"
export * from "./LoadingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports